import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { eColumnType } from '@hub/generated/enums';
import { GridDto, GridColumnDto } from '@hub/generated/models';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { SortMeta, SelectItem } from 'primeng/api';
import { GridStylingDto } from '@hub/models/grids/GridStylingDto';
import { LookUps } from '@hub/common/LookUps';
import { Constants } from '@hub/common/Constants';

@Component({
  selector: 'app-grid-settings-columns',
  templateUrl: './grid-settings-columns.component.html'
})
export class GridSettingsColumnsComponent {
  constructor() {
    this.columnTypes = LookUps.getColumnTypesLu();
  }

  // Enumerations
  type = eColumnType;
  columnTypes: SelectItem[] = [];

  @Input() GridData: GridDto;

  addNewColumn() {
    var column = new GridColumnDto();
    column.Id = Constants.GUID_EMPTY;
    column.Order = Math.max.apply(Math, this.GridData.Columns.map(item => item.Order)) + 1;
    column.Width = 100;
    this.GridData.Columns.push(column);
  }

  removeColumn(column) {
    const index = this.GridData.Columns.indexOf(column, 0);
    if (index > -1) {
      this.GridData.Columns.splice(index, 1);
    }
  }
}
